<template>
  <section class="scene">
    <!-- people -->
    <img alt="Mage" src="@/assets/images/people/mage/left/stand/0.png" class="person person--mage">
    <img alt="Piggy" src="@/assets/images/people/piggy.png" class="person person--piggy">
    <!-- content -->
    <!--
    <div class="content content--top">
      <div class="container">
        <h2 class="title">
          Millions of players ...
        </h2>
      </div>
    </div>
    -->
  </section>
</template>

<script>
export default {
  name: 'VillageFriends'
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/landing/mixins.scss';

.person--mage {
  width: 230px;
  bottom: -84px;
  left: 40%;

  @include breakpoint(sm) {
    left: 30%;
  }
  @include breakpoint(md) {
    left: 8%;
  }
  @include breakpoint(lg) {
    left: 20%;
  }
  @include breakpoint(xl) {
    left: 30%;
  }
}
.person--piggy {
  display: none;
  bottom: 75px;
  right: -5%;

  @include breakpoint(md) {
    display: block;
    right: -28px;
  }
  @media (min-width: 768px) and (max-width: 800px) {
    right: -68px;
  }
  @include breakpoint(lg) {
    right: 1%
  }
}
@media only screen and (max-height: 440px) and (orientation: landscape) {
  .person--mage {
    bottom: -114px;
  }
  .person--piggy {
    bottom: 45px;
  }
}
</style>
